/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiIdpSubmissionsDirectDivisionLayoutsGet } from '../fn/idp-submissions-direct/api-idp-submissions-direct-division-layouts-get';
import { ApiIdpSubmissionsDirectDivisionLayoutsGet$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-division-layouts-get';
import { apiIdpSubmissionsDirectDivisionLayoutsPut } from '../fn/idp-submissions-direct/api-idp-submissions-direct-division-layouts-put';
import { ApiIdpSubmissionsDirectDivisionLayoutsPut$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-division-layouts-put';
import { apiIdpSubmissionsDirectDocumentsPdfPost } from '../fn/idp-submissions-direct/api-idp-submissions-direct-documents-pdf-post';
import { ApiIdpSubmissionsDirectDocumentsPdfPost$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-documents-pdf-post';
import { apiIdpSubmissionsDirectDocumentsPdfPost$Plain } from '../fn/idp-submissions-direct/api-idp-submissions-direct-documents-pdf-post-plain';
import { ApiIdpSubmissionsDirectDocumentsPdfPost$Plain$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-documents-pdf-post-plain';
import { apiIdpSubmissionsDirectGet } from '../fn/idp-submissions-direct/api-idp-submissions-direct-get';
import { ApiIdpSubmissionsDirectGet$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-get';
import { apiIdpSubmissionsDirectGet$Plain } from '../fn/idp-submissions-direct/api-idp-submissions-direct-get-plain';
import { ApiIdpSubmissionsDirectGet$Plain$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-get-plain';
import { apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet } from '../fn/idp-submissions-direct/api-idp-submissions-direct-submission-extraction-submission-id-document-id-get';
import { ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-submission-extraction-submission-id-document-id-get';
import { apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain } from '../fn/idp-submissions-direct/api-idp-submissions-direct-submission-extraction-submission-id-document-id-get-plain';
import { ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-submission-extraction-submission-id-document-id-get-plain';
import { apiIdpSubmissionsDirectSubmissionExtractionUpdatePost } from '../fn/idp-submissions-direct/api-idp-submissions-direct-submission-extraction-update-post';
import { ApiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-submission-extraction-update-post';
import { apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain } from '../fn/idp-submissions-direct/api-idp-submissions-direct-submission-extraction-update-post-plain';
import { ApiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-submission-extraction-update-post-plain';
import { apiIdpSubmissionsDirectUpdateClassificationPost } from '../fn/idp-submissions-direct/api-idp-submissions-direct-update-classification-post';
import { ApiIdpSubmissionsDirectUpdateClassificationPost$Params } from '../fn/idp-submissions-direct/api-idp-submissions-direct-update-classification-post';
import { apiIdpSubmissionDirectDeletePost } from '../fn/idp-submissions-direct/api-idp-submission-direct-delete-post';
import { ApiIdpSubmissionDirectDeletePost$Params } from '../fn/idp-submissions-direct/api-idp-submission-direct-delete-post';
import { IdpSubmissionResponse } from '../models/idp-submission-response';
import { SubmissionExtractionResponseDto } from '../models/submission-extraction-response-dto';
import { UpdateExtractionResponseDto } from '../models/update-extraction-response-dto';

@Injectable({ providedIn: 'root' })
export class IdpSubmissionsDirectService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiIdpSubmissionsDirectGet()` */
  static readonly ApiIdpSubmissionsDirectGetPath = '/api/idp/submissions-direct';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectGet$Plain$Response(params?: ApiIdpSubmissionsDirectGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<IdpSubmissionResponse>> {
    return apiIdpSubmissionsDirectGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectGet$Plain(params?: ApiIdpSubmissionsDirectGet$Plain$Params, context?: HttpContext): Observable<IdpSubmissionResponse> {
    return this.apiIdpSubmissionsDirectGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<IdpSubmissionResponse>): IdpSubmissionResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectGet$Response(params?: ApiIdpSubmissionsDirectGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IdpSubmissionResponse>> {
    return apiIdpSubmissionsDirectGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectGet(params?: ApiIdpSubmissionsDirectGet$Params, context?: HttpContext): Observable<IdpSubmissionResponse> {
    return this.apiIdpSubmissionsDirectGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<IdpSubmissionResponse>): IdpSubmissionResponse => r.body)
    );
  }

  /** Path part for operation `apiIdpSubmissionsDirectUpdateClassificationPost()` */
  static readonly ApiIdpSubmissionsDirectUpdateClassificationPostPath = '/api/idp/submissions-direct/update-classification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectUpdateClassificationPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectUpdateClassificationPost$Response(params?: ApiIdpSubmissionsDirectUpdateClassificationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiIdpSubmissionsDirectUpdateClassificationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectUpdateClassificationPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectUpdateClassificationPost(params?: ApiIdpSubmissionsDirectUpdateClassificationPost$Params, context?: HttpContext): Observable<void> {
    return this.apiIdpSubmissionsDirectUpdateClassificationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiIdpSubmissionsDirectDocumentsPdfPost()` */
  static readonly ApiIdpSubmissionsDirectDocumentsPdfPostPath = '/api/idp/submissions-direct/documents/pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectDocumentsPdfPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectDocumentsPdfPost$Plain$Response(params?: ApiIdpSubmissionsDirectDocumentsPdfPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiIdpSubmissionsDirectDocumentsPdfPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectDocumentsPdfPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectDocumentsPdfPost$Plain(params?: ApiIdpSubmissionsDirectDocumentsPdfPost$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.apiIdpSubmissionsDirectDocumentsPdfPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectDocumentsPdfPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectDocumentsPdfPost$Response(params?: ApiIdpSubmissionsDirectDocumentsPdfPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiIdpSubmissionsDirectDocumentsPdfPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectDocumentsPdfPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectDocumentsPdfPost(params?: ApiIdpSubmissionsDirectDocumentsPdfPost$Params, context?: HttpContext): Observable<Blob> {
    return this.apiIdpSubmissionsDirectDocumentsPdfPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet()` */
  static readonly ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGetPath = '/api/idp/submissions-direct/submission-extraction/{submissionId}/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain$Response(params: ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionExtractionResponseDto>> {
    return apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain(params: ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain$Params, context?: HttpContext): Observable<SubmissionExtractionResponseDto> {
    return this.apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionExtractionResponseDto>): SubmissionExtractionResponseDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Response(params: ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionExtractionResponseDto>> {
    return apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet(params: ApiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Params, context?: HttpContext): Observable<SubmissionExtractionResponseDto> {
    return this.apiIdpSubmissionsDirectSubmissionExtractionSubmissionIdDocumentIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionExtractionResponseDto>): SubmissionExtractionResponseDto => r.body)
    );
  }

  /** Path part for operation `apiIdpSubmissionsDirectSubmissionExtractionUpdatePost()` */
  static readonly ApiIdpSubmissionsDirectSubmissionExtractionUpdatePostPath = '/api/idp/submissions-direct/submission-extraction/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain$Response(params?: ApiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateExtractionResponseDto>> {
    return apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain(params?: ApiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain$Params, context?: HttpContext): Observable<UpdateExtractionResponseDto> {
    return this.apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateExtractionResponseDto>): UpdateExtractionResponseDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectSubmissionExtractionUpdatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Response(params?: ApiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateExtractionResponseDto>> {
    return apiIdpSubmissionsDirectSubmissionExtractionUpdatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectSubmissionExtractionUpdatePost(params?: ApiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Params, context?: HttpContext): Observable<UpdateExtractionResponseDto> {
    return this.apiIdpSubmissionsDirectSubmissionExtractionUpdatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateExtractionResponseDto>): UpdateExtractionResponseDto => r.body)
    );
  }

  /** Path part for operation `apiIdpSubmissionsDirectDivisionLayoutsGet()` */
  static readonly ApiIdpSubmissionsDirectDivisionLayoutsGetPath = '/api/idp/submissions-direct/division-layouts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectDivisionLayoutsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectDivisionLayoutsGet$Response(params?: ApiIdpSubmissionsDirectDivisionLayoutsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiIdpSubmissionsDirectDivisionLayoutsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectDivisionLayoutsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpSubmissionsDirectDivisionLayoutsGet(params?: ApiIdpSubmissionsDirectDivisionLayoutsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiIdpSubmissionsDirectDivisionLayoutsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiIdpSubmissionsDirectDivisionLayoutsPut()` */
  static readonly ApiIdpSubmissionsDirectDivisionLayoutsPutPath = '/api/idp/submissions-direct/division-layouts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionsDirectDivisionLayoutsPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectDivisionLayoutsPut$Response(params?: ApiIdpSubmissionsDirectDivisionLayoutsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiIdpSubmissionsDirectDivisionLayoutsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionsDirectDivisionLayoutsPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpSubmissionsDirectDivisionLayoutsPut(params?: ApiIdpSubmissionsDirectDivisionLayoutsPut$Params, context?: HttpContext): Observable<void> {
    return this.apiIdpSubmissionsDirectDivisionLayoutsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiIdpSubmissionDirectDeletePost()` */
  static readonly ApiIdpSubmissionDirectDeletePostPath = '/api/idp/submissions-direct/delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpSubmissionDirectDeletePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiIdpSubmissionDirectDeletePost$Response(params?: ApiIdpSubmissionDirectDeletePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiIdpSubmissionDirectDeletePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpSubmissionDirectDeletePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiIdpSubmissionDirectDeletePost(params?: ApiIdpSubmissionDirectDeletePost$Params, context?: HttpContext): Observable<void> {
    return this.apiIdpSubmissionDirectDeletePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
